import queryString from 'query-string';

import { genericService } from '../_services';

function getWord(verb) {
  switch(verb) {

  case 'OPTIONS':
    return 'OPTIONS_LOADED';

  case 'POST':
    return 'CREATED';

  case 'PATCH':
    return 'UPDATED';

  case 'DELETE':
    return 'DELETED';

  default:
    return 'LOADED';
  }
}

function getResourcePath(className) {

  switch(className.toUpperCase()) {

  case 'CLIENT':
    return 'clients';

  case 'ACCOUNT':
    return 'accounts';

  case 'SERVICE':
    return 'services';

  case 'GST':
    return 'gst';

  case 'TDS':
    return 'tds';

  case 'PAYMENT':
    return 'payments';

  case 'GSTACCOUNT':
    return 'gst-accounts';

  case 'SUPPLIER':
    return 'suppliers';

  case 'INVOICE':
    return 'invoices';

  case 'PURCHASEINVOICE':
    return 'purchase-invoices';

  default:
    console.error('unknown path', className);
    return undefined;
  }
}

export function getNiceClassname(name) {
  // Replaces camelcase letter with _ eg. ReservationLine -> RESERVATION_LINE
  if (name.match('^[A-Z]+$')) {
    return name;
  }
  return name[0].toUpperCase() + name.slice(1).replace(/([A-Z])/g, '_$1').toUpperCase();
}

function getAction(verb, obj, detailRoute) {
  let str = getNiceClassname(obj.class_name);
  if (verb === 'GET' && obj.id === undefined) {
    if (str[str.length - 1] === 'Y'){
      str = str.slice(0, str.length - 1);
      str += 'IES';
    } else {
      str += 'S';
    }
  }

  if (detailRoute) {
    str += `_${detailRoute}`;
  }

  return `${str}_${getWord(verb)}`.toUpperCase();
}

function getOperation(verb) {
  if (verb === 'POST' || verb === 'PATCH' || verb === 'PUT') {
    return 'WRITE';
  }
  if (verb === 'DELETE') {
    return 'DELETE';
  }
  return 'READ';
}

function getProgressKey(obj, verb) {
  return `${getNiceClassname(obj.class_name)}_${getOperation(verb)}_IN_PROGRESS`;
}

const doRequest = (url, verb, obj, detailRoute, posId) => (dispatch) => {
  const requestData = verb === 'GET' ? undefined : obj;

  return new Promise((resolve, reject) => {
    dispatch({
      type: 'PROGRESS',
      key: getProgressKey(obj, verb),
      flag: true
    });

    genericService.apiCall(url, verb, requestData)
      .then((data) => {
        dispatch({
          type: 'PROGRESS',
          key: getProgressKey(obj, verb),
          flag: false
        });
        dispatch(success(data));
        resolve(data);
      }, (error) => {
        dispatch({
          type: 'PROGRESS',
          key: getProgressKey(obj, verb),
          flag: false
        });
        if (error && error.global_alert) {
          // notify.show(error.global_alert.join(', '), 'error');
        }
        console.log('error here: ', error);
        dispatch(failure(error));
        reject(error);
      });
  });
  function success(data) { return { type: `${getAction(verb, obj, detailRoute)}`, data: verb === 'DELETE' ? obj : data, posId }; }
  function failure(errors) { return { type: `${getNiceClassname(obj.class_name)}_ERRORS`, errors }; }
};

export const restApiCall = params => (dispatch) => {
  const defaultOptions = {
    verb: 'GET',
    data: undefined, //data sounds better than obj
    queryParams: undefined,
    detailRoute: undefined,
    url: undefined
  };

  const { channelId, verb, posId, obj, queryParams, detailRoute } = { ...defaultOptions, ...params };
  let { data, url } = { ...defaultOptions, ...params };
  // Special api call wrapper for POS
  // `/api/v1/<establishment_pk>/pos/<pos_id>/<resource>/<resource_id>/`

  data = { ...data, ...obj };

  url = '/api/v1/';

  if (channelId) {
    url += `${channelId}/`;
  }

  url += `${getResourcePath(data.class_name)}/`;

  if (data.id && verb !== 'OPTIONS') {
    url += `${data.id}/`;
  }

  if (detailRoute) {
    url += `${detailRoute}/`;
  }

  if (queryParams) {
    url += `?${queryString.stringify(queryParams)}`;
  }
  return dispatch(doRequest(url, verb, data, detailRoute, posId));
};



// WEBPACK FOOTER //
// ./src/_actions/generic.actions.js